import { React, useEffect, useState, useCallback } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Card, Col, Row } from "reactstrap";
import "../../assets/scss/style.css";
import { getBrokersWithPaymentIssues } from "services/services";
import { UncontrolledTooltip } from "reactstrap";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { alerShow, dateformat } from "admin/commonFunction";

const PaymentFailures = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [listingData, setListingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 20;
  const [statusFilter, setStatusFilter] = useState("");

  const fetchData = useCallback(
    async (pageNumber, pageSize, status = "") => {
      try {
        setLoading(true);
        const res = await getBrokersWithPaymentIssues(pageNumber, pageSize, status);

        const payload = res?.data ?? res;
        let items = [];
        if (Array.isArray(payload)) {
          items = payload;
        } else if (payload && typeof payload === "object") {
          items = payload.items || payload.data || [];
        }

        console.log("Payment issues data:", items);
        setListingData(items);

        // Determine total pages
        const explicitPages =
          Number(
            payload?.totalPages ||
              payload?.pageCount ||
              payload?.pages ||
              payload?.pagination?.totalPages ||
              0
          ) || 0;
        if (explicitPages > 0) {
          setTotalCount(explicitPages);
        } else {
          const totalRecords =
            Number(
              payload?.total ||
                payload?.totalCount ||
                payload?.count ||
                payload?.totalRecords ||
                payload?.pagination?.total ||
                0
            ) || 0;
          let pages = Math.ceil(totalRecords / pageSize);
          if (pages < 1 && items.length > 0) pages = 1;
          setTotalCount(pages);
        }
      } catch (err) {
        console.error(err);
        toast.error(err?.response?.data?.error || err?.message || "Failed to fetch payment issues");
        setListingData([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    fetchData(currentPage, perPage, statusFilter);
  }, [currentPage, statusFilter, fetchData]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    setCurrentPage(1);
    fetchData(1, perPage, value);
  };

  const handleViewBroker = (brokerId, companyName) => {
    history.push(`/admin/brokers/${brokerId}`, {
      companyName: companyName,
    });
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "past_due":
        return "bg-warning";
      case "canceled":
        return "bg-danger";
      case "unpaid":
        return "bg-danger";
      case "incomplete":
        return "bg-info";
      case "incomplete_expired":
        return "bg-secondary";
      default:
        return "bg-secondary";
    }
  };

  const formatStatus = (status) => {
    if (!status) return "-";
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row className="d-flex align-items-center">
          <Col lg="6">
            <h5 className="text-color-gredient">Payment Failures</h5>
          </Col>
          <Col lg="6" className="d-flex align-items-center justify-content-end">
            <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
              <select
                className="form-control select2 mb-xxl-0"
                style={{ width: "200px" }}
                value={statusFilter}
                onChange={handleStatusFilter}
              >
                <option value="">All Status</option>
                <option value="past_due">Past Due</option>
                <option value="canceled">Canceled</option>
                <option value="unpaid">Unpaid</option>
                <option value="incomplete">Incomplete</option>
                <option value="incomplete_expired">Incomplete Expired</option>
              </select>
            </div>
          </Col>
        </Row>
        <div className="table-responsive">
          <Table
            id="payment-failures-table"
            className="table common-table table-nowrap table-bordered"
          >
            <Thead>
              <Tr>
                <Th>Sr No</Th>
                <Th>Broker</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th>Office Address</Th>
                <Th>Package Name</Th>
                <Th>Package Price</Th>
                <Th>Status</Th>
                <Th>Payment Failed At</Th>
                <Th>Failure Reason</Th>
                <Th>Amount Due</Th>
                <Th>Attempt Count</Th>
                <Th>Next Payment Date</Th>
               
              </Tr>
            </Thead>
            <Tbody>
              {loading ? (
                <Tr>
                  <Td colSpan="14">Loading...</Td>
                </Tr>
              ) : listingData.length > 0 ? (
                listingData.map((element, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * perPage + (index + 1)}</td>
                    <td>{element?.companyName || "-"}</td>
                    <td>{element?.email || "-"}</td>
                    <td>{element?.phoneNumber || "-"}</td>
                    <td>{element?.officeAddress || "-"}</td>
                    <td>
                      {element?.subscription?.packageName || "-"}
                    </td>
                    <td>
                      {element?.subscription?.packagePrice
                        ? `$${element.subscription.packagePrice.toFixed(2)}`
                        : "-"}
                    </td>
                    <td>
                      {element?.subscription?.status ? (
                        <span
                          className={`badge ${getStatusBadgeClass(
                            element.subscription.status
                          )}`}
                        >
                          {formatStatus(element.subscription.status)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {element?.subscription?.paymentFailedAt
                        ? dateformat(element.subscription.paymentFailedAt)
                        : "-"}
                    </td>
                    <td>
                      {element?.subscription?.paymentFailureReason || "-"}
                    </td>
                    <td>
                      {element?.subscription?.amountDue
                        ? `$${element.subscription.amountDue.toFixed(2)}`
                        : "-"}
                    </td>
                    <td>{element?.subscription?.attemptCount || 0}</td>
                    <td>
                      {element?.subscription?.nextPaymentDate
                        ? dateformat(element.subscription.nextPaymentDate)
                        : "-"}
                    </td>
                    
                  </tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="14" className="text-center">
                    No Records Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
        <Row className="mt-2">
          <Col md={9}></Col>
          <Col md={3}>
            <Pagination
              {...bootstrap5PaginationPreset}
              current={currentPage}
              total={Math.max(1, totalCount)}
              onPageChange={(page) => handlePageClick(page)}
              className="pagination justify-content-end gap-1"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PaymentFailures;

